import React, { FC } from "react"
import { graphql } from "gatsby"
import { renderRichText } from "gatsby-source-contentful/rich-text"

import { ContentCalloutFragmentFragment } from "@graphqlTypes"
import { ImageType } from "@srcTypes"

import AvatarWithName from "@components/AvatarWithName/AvatarWithName"

import { textOptions } from "../../Content.utils"

import {
  ContentCalloutDIV,
} from "./ContentCallout.styles"

const ContentCallout: FC<ContentCalloutFragmentFragment> = ({
  callout,
  avatarImage,
  name,
  role,
}) => (
  <ContentCalloutDIV>
    <div className="content">
      {callout && renderRichText(callout, textOptions)}
    </div>
    {(avatarImage && name && role) && (
      <AvatarWithName
        image={avatarImage as ImageType}
        name={name}
        bio={role}
      />
    )}
  </ContentCalloutDIV>
)

export const ContentCalloutFragment = graphql`
  fragment ContentCalloutFragment on ContentfulContentBlockCallout {
    contentful_id
    avatarImage {
      imgixImage {
        gatsbyImageData(width: 160)
      }
    }
    callout: content {
      raw
    }
    entryTitle
    name
    role
  }
`

export default ContentCallout
